import { Text, Tag, Input } from '@chakra-ui/react';


const WidgetPreview = ({tempWidget, setTempWidget, queues, ccxQueues, symbeeStats}) => {
    

    function queueNames(queueIds) {
        let queueNamesArray = [];
        for (var i = 0; i< queues.length; i++){
            if(queueIds.includes(queues[i]['arn'])) {
                queueNamesArray.push(queues[i]['name']);
            }
        }
        if(symbeeStats){
            for (var q = 0; q< ccxQueues.length; q++){
                if(queueIds.includes(ccxQueues[q]['arn'])) {
                    queueNamesArray.push(ccxQueues[q]['name']);
                }
            }
        }
        
        return queueNamesArray;
    }
    
    
    return (
        <div style={{width: '50%'}}>
            <div>
                <Text as='b'> Selected Queue(s): </Text>
                {queueNames(tempWidget.arn).map((queue, itx) => {
                    return (<Tag color='teal' key={`${itx}-queuetag`}>{queue}</Tag>);
                })}
            </div>
            <div>
                <Text as='b'> Selected Metric: </Text>
                {tempWidget.statistic.map((metric, itz) => {
                    return (<Tag color='teal' key={`${itz}-queuetag`}>{metric}</Tag>);
                })}
            </div>
            <div>
                <Text as='b'> Metric Class: </Text>
                <Tag color='teal'> {tempWidget.type}</Tag>
            </div>
            <div>
                <Text as='b'> Thresholds: </Text>
                { tempWidget.thresholds?.first ? <Tag colorScheme='yellow' variant='subtle'> {`${tempWidget.thresholds?.first?.operand} ${tempWidget.thresholds?.first?.value}`}</Tag> : null}
                { tempWidget.thresholds?.second ? <Tag colorScheme='red' variant='subtle'>{`${tempWidget.thresholds?.second?.operand} ${tempWidget.thresholds?.second?.value}`}</Tag> : null}
                
            </div>
            <div>
                <Text as='b'> Widget Title: </Text>
                <Input 
                    color='red'
                    placeholder='Set a widget title'
                    _placeholder={{ color: 'inherit' }}
                    value={tempWidget.name}
                    onChange={(e) => setTempWidget({...tempWidget, name: e.target.value})}>
                </Input>
            </div>
        </div>
        
       
    );
    
};

export default WidgetPreview;